import React from 'react';

import { SUPPORTED_LANGUAGES } from './languages';
import { useLanguage } from './LanguageContext';

export default function LanguageSelect({ id, className, variant, value, onChange, labelKey }) {
    const { language, setLanguage, t } = useLanguage();
    const isControlled = typeof onChange === 'function' && value != null;
    const current = isControlled ? value : language;
    const label = t(labelKey || 'language.label');
    const classes = [
        'app-language-select',
        variant === 'login' ? 'app-language-select--login' : '',
        variant === 'settings' ? 'app-language-select--settings' : '',
        className || '',
    ].filter(Boolean).join(' ');

    return (
        <label className={classes} htmlFor={id}>
            <span className="app-language-select__label">{label}</span>
            <select
                id={id}
                value={current}
                onChange={(event) => {
                    if (isControlled) {
                        onChange(event.target.value);
                    } else {
                        setLanguage(event.target.value);
                    }
                }}
                aria-label={label}
            >
                {SUPPORTED_LANGUAGES.map((item) => (
                    <option key={item.code} value={item.code}>
                        {item.nativeLabel}
                    </option>
                ))}
            </select>
        </label>
    );
}
